window.SlideshowObjs = window.SlideshowObjs || [];
function initSlideshow(section) {
  section =
    typeof section === typeof undefined || section == "undefined"
      ? document
      : section;
  var swiperItems = section.querySelectorAll(".swiper");
  swiperItems.forEach(function (swiperItem, index) {
    if (swiperItem.classList.contains("product-media-gallery")) return false;
    var _this = swiperItem,
      sliderOptions = _this.getAttribute("data-slider-options"),
      isNumberNavigation = _this.getAttribute("data-swiper-number-navigation");
    var isNumberPaginationProgress =
      _this.getAttribute("data-swiper-number-pagination-progress") || false;
    if (typeof sliderOptions !== "undefined" && sliderOptions !== null) {
      sliderOptions = JSON.parse(sliderOptions);
      console.log(sliderOptions);
      if (sliderOptions.hasOwnProperty("effect")) {
        if (sliderOptions.effect == "creative") {
          sliderOptions["creativeEffect"] = {
            prev: {
              translate: [0, 0, -400],
            },
            next: {
              translate: ["100%", 0, 0],
            },
          };
        }

        if (sliderOptions.effect == "fade") {
          sliderOptions["fadeEffect"] = {
            crossFade: true,
          };
        }
      }

      /* If user have provided "data-thumb-direction" attribute then below code will execute */
      if (
        sliderOptions["thumbs"] != "" &&
        sliderOptions["thumbs"] != undefined
      ) {
        var mdThumbDirection = _this.getAttribute("data-thumb-direction");
        sliderBreakPoint =
          _this.getAttribute("data-thumb-breakpoint") !== "undefined"
            ? _this.getAttribute("data-thumb-breakpoint")
            : sliderBreakPoint;

        var viewportWidth = window.innerWidth;
        if (viewportWidth > 767) {
          sliderOptions["thumbs"]["autoScrollOffset"] = 1;
        }

        if (mdThumbDirection != "" && mdThumbDirection != undefined) {
          var thumbDirection =
            sliderOptions["thumbs"]["swiper"]["direction"] != "" &&
            sliderOptions["thumbs"]["swiper"]["direction"] != undefined
              ? sliderOptions["thumbs"]["swiper"]["direction"]
              : mdThumbDirection;
          sliderOptions["thumbs"]["swiper"]["on"] = {
            init: function () {
              if (getWindowWidth() <= sliderBreakPoint) {
                this.changeDirection(mdThumbDirection);
              } else {
                this.changeDirection(thumbDirection);
              }
              this.update();
            },
            resize: function () {
              if (getWindowWidth() <= sliderBreakPoint) {
                this.changeDirection(mdThumbDirection);
              } else {
                this.changeDirection(thumbDirection);
              }
              this.update();
            },
          };
        }
      }
      sliderOptions["on"] = {
        init: function () {
          var length = this.loopedSlides
            ? this.slides.length - 2
            : this.slides.length;
          /* For Number Navigation - On Swiper Initialize - Add Navigation Number */
          if (isNumberNavigation == "1") {
            _this.find(".swiper-button-next").textContent("02");
            _this.find(".swiper-button-prev").textContent("0" + length);
          }
          /* End */
          /* Number pagination progress */
          if (isNumberPaginationProgress) {
            _this.parentNode.find(".number-next").textContent("0" + length);
            _this.parentNode.find(".number-prev").textContent("01");
            _this.parentNode
              .find(".swiper-pagination-progress")[0]
              .style.setProperty(
                "--swiper-progress",
                (100 / length).toFixed(2) + "%"
              );
          }
          /* End */
        },
        slideChange: function (swiper) {
          var length = this.loopedSlides
              ? this.slides.length - 2
              : this.slides.length,
            active = this.realIndex + 1,
            next = active + 1,
            prev = active - 1;
          if (active == 1) {
            prev = length;
          }
          if (active == length) {
            next = 1;
          }
          /* For Number Navigation - On Swiper Slide Change - Change Navigation Number */
          if (isNumberNavigation == "1") {
            _this
              .find(".swiper-button-next")
              .textContent(next < 10 ? "0" + next : next);
            _this
              .find(".swiper-button-prev")
              .textContent(prev < 10 ? "0" + prev : prev);
          }
          /* End */
          /* Number pagination progress */
          if (isNumberPaginationProgress) {
            _this.parentNode.find(".number-prev").each(function () {
              $(this).textContent(active < 10 ? "0" + active : active);
            });
            _this.parentNode
              .find(".swiper-pagination-progress")[0]
              .style.setProperty(
                "--swiper-progress",
                ((100 / length) * active).toFixed(2) + "%"
              );
          }
          /* End */
          if (swiper.$el.hasClass("product-image-main")) {
            const currSlide = swiper.slides[swiper.activeIndex];
            const mediaType = currSlide.dataset.mediaType || false;
            const mediaHost = currSlide.dataset.mediaHost || false;

            // Pause all videos
            if (
              typeof window.currPlayingVid != typeof undefined &&
              window.currPlayingVid != "undefined" &&
              window.currPlayingVid.plyrInstance.playing
            ) {
              window.currPlayingVid.plyrInstance.pause();
            }

            if (mediaType == "model") {
              swiper.allowTouchMove = false;
            } else {
              swiper.allowTouchMove = true;
            }
          }
        },
      };
      swiperItem.sliderOptions = sliderOptions;
      var swiperObj = new Swiper(swiperItem, sliderOptions);
      window.SlideshowObjs.push(swiperItem);
    }
  });
}

let product_media_sklider = "";
function pdpslider() {
  let product_slider = document.querySelector("[data-pdp-slider]");
  if (product_slider) {
    (sliderOptions = product_slider.getAttribute("data-slider-options")),
      (slideroptionConfig = JSON.parse(sliderOptions));
    product_media_sklider = new Swiper(
      "[data-main-pdp-swiper]",
      slideroptionConfig
    );
  }
  let product_slider_rec = document.querySelector("recently-viewed");
  if (product_slider_rec) {
    let sliderOptions_rec = product_slider_rec
        .querySelector("[data-slider-options]")
        .getAttribute("data-slider-options"),
      slideroptionConfig_rec = JSON.parse(sliderOptions_rec);
    recently_viewed_slider = new Swiper(
      ".recently-viewed-slider",
      slideroptionConfig_rec
    );
  }
}

(function () {
  initSlideshow();
  pdpslider();
})();

document.addEventListener("shopify:section:load", function (event) {
  initSlideshow();
  pdpslider();
});

/****** Swiper slide show End******/

//pagination
function pagination_click_fun() {
  let loadMoreBtn = document.querySelector("[data-pagination-btn]") || null;
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener("click", function (e) {
      e.preventDefault();
      pagination_items_get_fun(loadMoreBtn.getAttribute("href"));
    });
  }
}
if (
  document.body.classList.contains("template-collection") ||
  document.body.classList.contains("template-blog")
) {
  if (window.location.href.includes("?page=")) {
    window.location.replace(window.location.href.split("?")[0]);
  }
}
pagination_click_fun();
function pagination_items_get_fun(loadMoreBtn) {
  fetch(loadMoreBtn)
    .then((response) => {
      return response.text();
    })
    .then((response) => {
      const parser = new DOMParser();
      const html = parser.parseFromString(response, "text/html");
      let proGrid = document.querySelector("[data-product-main-wrapper]");
      if (proGrid) {
        // replace product grid HTML
        proGrid.innerHTML =
          document.querySelector("[data-product-main-wrapper]").innerHTML +
          html.querySelector("[data-product-main-wrapper]").innerHTML;
        // replace pagination HTML
        window.history.replaceState({}, null, loadMoreBtn); // added curent pagination link
        let pagination = document.querySelector("[data-pagination-link]");
        let newPagination = html.querySelector("[data-pagination-link]");
        if (pagination && newPagination) {
          pagination.innerHTML = newPagination.innerHTML;
          pagination_click_fun(); // reinit click event
        }
      }
    });
}

// recantely product script start
window.theme = window.theme || {};
theme.recentlyViewed = {
  recent: {}, // will store handle+url of recent products
  productInfo: {}, // will store product data to reduce API calls
};

theme.recentlyViewed.localStorage = window.localStorage.getItem("theme-recent");
if (theme.recentlyViewed.localStorage) {
  theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.localStorage);
}

window.localStorage.removeItem("bundleproducts");
theme.customBundle = {
  recent: {}, // will store handle+url of recent products
  productInfo: {}, // will store product data to reduce API calls
};

theme.customBundle.localStorage = window.localStorage.getItem("bundleproducts");
if (theme.customBundle.localStorage) {
  theme.customBundle.recent = JSON.parse(theme.customBundle.localStorage);
}

theme.Currency = (function () {
  var moneyFormat = "${{amount}}";
  var superScript = theme && theme.settings && theme.settings.superScriptPrice;

  function formatMoney(cents, format) {
    if (!format) {
      format = window.cartStrings.moneyFormat;
    }

    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = theme.utils.defaultTo(precision, 2);
      thousands = theme.utils.defaultTo(thousands, ",");
      decimal = theme.utils.defaultTo(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);

        if (superScript && value && value.includes(".")) {
          value = value.replace(".", "<sup>") + "</sup>";
        }

        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");

        if (superScript && value && value.includes(",")) {
          value = value.replace(",", "<sup>") + "</sup>";
        }

        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function getBaseUnit(variant) {
    if (!variant) {
      return;
    }

    if (
      !variant.unit_price_measurement ||
      !variant.unit_price_measurement.reference_value
    ) {
      return;
    }

    return variant.unit_price_measurement.reference_value === 1
      ? variant.unit_price_measurement.reference_unit
      : variant.unit_price_measurement.reference_value +
          variant.unit_price_measurement.reference_unit;
  }

  return {
    formatMoney: formatMoney,
    getBaseUnit: getBaseUnit,
  };
})();

theme.utils = {
  defaultTo: function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },

  wrap: function (el, wrapper) {
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  },

  debounce: function (wait, callback, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) callback.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) callback.apply(context, args);
    };
  },

  throttle: function (limit, callback) {
    var waiting = false;
    return function () {
      if (!waiting) {
        callback.apply(this, arguments);
        waiting = true;
        setTimeout(function () {
          waiting = false;
        }, limit);
      }
    };
  },

  prepareTransition: function (el, callback) {
    el.addEventListener("transitionend", removeClass);

    function removeClass(evt) {
      el.classList.remove("is-transitioning");
      el.removeEventListener("transitionend", removeClass);
    }

    el.classList.add("is-transitioning");
    el.offsetWidth; // check offsetWidth to force the style rendering

    if (typeof callback === "function") {
      callback();
    }
  },

  // _.compact from lodash
  // Creates an array with all falsey values removed. The values `false`, `null`,
  // `0`, `""`, `undefined`, and `NaN` are falsey.
  // _.compact([0, 1, false, 2, '', 3]);
  // => [1, 2, 3]
  compact: function (array) {
    var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  serialize: function (form) {
    var arr = [];
    Array.prototype.slice.call(form.elements).forEach(function (field) {
      if (
        !field.name ||
        field.disabled ||
        ["file", "reset", "submit", "button"].indexOf(field.type) > -1
      )
        return;
      if (field.type === "select-multiple") {
        Array.prototype.slice.call(field.options).forEach(function (option) {
          if (!option.selected) return;
          arr.push(
            encodeURIComponent(field.name) +
              "=" +
              encodeURIComponent(option.value)
          );
        });
        return;
      }
      if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked)
        return;
      arr.push(
        encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value)
      );
    });
    return arr.join("&");
  },
};

theme.buildProductGridItem = function (
  items,
  gridWidth,
  rowOf,
  imageSizes,
  enable_quick_add
) {
  var output = "";

  items.forEach((product) => {
    var image = theme.buildProductImage(product, imageSizes);

    let priceMarkup = `<div class="grid-product__price">${theme.Currency.formatMoney(
      product.price_min,
      theme.moneyFormat
    )}</div>`;
    let vendorMarkup = `<div class="grid-product__vendor">${product.vendor}</div>`;
    let quick_add_code = "";
    if (enable_quick_add)
      quick_add_code = `<product-form data-section-id="{{ section.id }}"><form method="post" action="/cart/add" id="quick-add-${product.id}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="${product.variants[0].id}" class="product-variant-id"><input type="hidden" name="id" value="${product.variants[0].id}" class="product-variant-id"><button id="quick-add-${product.id}-submit" type="submit"name="add" class="quick-add__submit button button--full-width button--secondary" aria-haspopup="dialog" aria-labelledby="quick-add-${product.id}-submit title-${product.id}"aria-live="polite" data-sold-out-message="true" <span>ADD TO CART</span><div class="loading__spinner hidden"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div></button></form></product-form>`;
    var markup = `
        <div class="${gridWidth}">
          <div class="grid-product__content">
            <a href="${product.url}" class="grid-product__link">
              <div class="grid-product__image-mask">
                ${image}
              </div>
              <div class="grid-product__meta">
                <div class="grid-product__title">${product.title}</div>
                ${priceMarkup}
                ${vendorMarkup}
                ${quick_add_code}
              </div>
            </a>
          </div>
        </div>
      `;

    output += markup;
  });

  return output;
};

theme.buildProductGridItem_bundle = function (items, imageSizes) {
  var output = "";
  var bundle_v_id;
  items.forEach((product) => {
    var image = theme.buildProductImage(product, imageSizes);
    if (!product.variants[0].available) {
      product.variants.forEach((vari) => {
        if (vari.available) {
          bundle_v_id = vari.id;
          return;
        }
      });
    } else {
      bundle_v_id = product.variants[0].id;
    }
    let priceMarkup = `<price>${theme.Currency.formatMoney(
      product.price_min,
      theme.moneyFormat
    )}</price>`;
    var markup = `
        <div class="added_product">
          <div class="added_item">
            <a href="${product.url}" class="grid-product__link">
              <div class="product-image">
                ${image}
              </div>
               <div class="product_details">
                <span>${product.title}</span>
                ${priceMarkup}
              </div>
            </a>
          </div>
          <div class="custom_quantity_selector">
            <quantity-input class="quantity" data-url="${product.handle}">
              <button class="quantity__button no-js-hidden" name="minus" type="button">
                <span class="visually-hidden">-</span>
              </button>
              <input
                class="quantity__input"
                type="number"
                name="quantity"
                value="${product.qty_value}"
                min="0"
                max="${product.max}"
                data-custom-check
                data-bundles-added-products
                data-vid=${bundle_v_id}
                data-price="${product.price_min}"
                data-max-qty="12"
                data-seling-plan-one-mo="${product.one_month}"
                data-seling-plan-two-mo="${product.two_month}"
                data-seling-plan-three-mo="${product.three_month}"
                data-stap-bundle="${product.qty_step}"
              />
              <button class="quantity__button no-js-hidden karton-coll-input-list" name="plus" type="button">
                <span class="visually-hidden">+</span>
              </button>
            </quantity-input>
          </div>         
        </div>
      `;

    output += markup;
  });

  return output;
};

theme.buildProductImage = function (product, imageSizes) {
  var size = "natural";
  var output = "";

  if (size === "natural") {
    const template = document.getElementById("naturalImageMarkup");
    const clonedMarkup = template.content.cloneNode(true);
    const imageEl = clonedMarkup.querySelector("img");
    const imageWrapperEl = clonedMarkup.querySelector(".image-wrap");

    imageWrapperEl.style.paddingBottom = `${product.image_aspect_ratio}%`;

    addImageProperties(imageEl, imageSizes);

    const imageDiv = document.createElement("div");
    imageDiv.appendChild(clonedMarkup);

    output = imageDiv.innerHTML;
  } else {
    const template = document.getElementById("fixedRatioImageMarkup");
    const clonedMarkup = template.content.cloneNode(true);
    const imageEl = clonedMarkup.querySelector("img");
    const imageWrapperEl = clonedMarkup.querySelector(".grid__image-ratio");

    imageWrapperEl.classList.add(`grid__image-ratio--${size}`);

    if (!theme.settings.productImageCover) {
      imageEl.classList.add("grid__image-contain");
    }

    addImageProperties(imageEl, imageSizes);

    const imageDiv = document.createElement("div");
    imageDiv.appendChild(clonedMarkup);

    output = imageDiv.innerHTML;
  }

  function addImageProperties(imageEl, imageSizes) {
    imageEl.src = product.image_responsive_url;
    imageEl.srcset = product.image_responsive_urls.toString();
    imageEl.alt = product.title;
    imageEl.sizes = imageSizes;
  }

  return output;
};

// recantely product script end

/****** theme custom menu appears on hover Start ******/
// Add this code make menu appears on hover
function bindMouseOverToMegaMenu(item) {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item
      .querySelector(".mega-menu__content, .header__submenu")
      .addEventListener("mouseover", () => {
        item.setAttribute("open", true);
      });
    item
      .querySelector(".mega-menu__content, .header__submenu")
      .addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
}
let main_header_iner_items = document.querySelector(".header__inline-menu");
if (main_header_iner_items) {
  let items = main_header_iner_items.querySelectorAll(
    "details.mega_menu_hover, details.drop-down-hover"
  );
  items.forEach(bindMouseOverToMegaMenu);
}
/****** theme custom menu appears on hover End ******/
